import React, { useMemo, useRef, useState } from "react";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import axios from "axios";
import Card from "../../../../components/Card/Card";
import CardBody from "../../../../components/Card/CardBody";
import SaveButton from "../../../../components/CustomInput/SaveButton";
import GridContainer from "../../../../components/Grid/GridContainer";
import GridItem from "../../../../components/Grid/GridItem";
import Button from "../../../../components/CustomButtons/Button";
import { CircularProgress } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import AuthenticationWrapper from "../../../../auth/AuthenticationWrapper";

function Service() {
  const [iframeUrl, setIframeUrl] = useState(null);
  const [index, setIndex] = useState(0);
  const [oauthbusy, setOauthbusy] = useState(false);
  const pollUrl = useRef(null);
  const { setValue, getValues } = useFormContext();

  const { vestigingId } = useFormContext();

  const syncStartValue = useWatch({ name: "volatile_salesarea_data__syncStart" });
  const [running, setRunning] = useState(syncStartValue > 0);
  const apiProviderValue = useWatch({ name: "apiProvider" });
  const mplusautosyncValue = useWatch({ name: "mplusautosync" });

  const customData = useWatch({ name: "custom_data" });
  const isMappsParent = !!customData?.multi_sales_area_sync?.isParent;

  const apiActions = useMemo(
    () => ({
      MRWINSTON: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/mrwinston/menu?vid=" + vestigingId,
          params: {
            debug: false,
            gtd: 1,
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/mrwinston/tables?vid=" + vestigingId,
          params: {
            debug: false,
            gtd: 0,
            vid: vestigingId,
          },
        },

        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      UNTILL: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/untill/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/untill/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment data"}
              tKey={"vestigingen.form.service.label.loadPaymentData"}
            />
          ),
          color: "info",
          url: "/import/untill/paymentids?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Update status"}
              tKey={"vestigingen.form.service.label.updateProductStatus"}
            />
          ),
          color: "info",
          url: "/import/untill/status?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Import customers"} tKey={"vestigingen.form.service.label.importCustomers"} />
          ),
          color: "warning",
          url: "/import/untill/customers?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load NFC cards"} tKey={"vestigingen.form.service.label.loadNfcCards"} />
          ),
          color: "warning",
          url: "/import/untill/nfccards?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      VECTRON: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/vectron/menu?&debug=true&gtd=true&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/vectron/tables?&debug=true&vid=" + vestigingId,
          params: {
            debug: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/vectron/menu?&debug=true&gtd=true&force=1&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      TRIVECLITE: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/triveclite/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
            queueImport: 1,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment data"}
              tKey={"vestigingen.form.service.label.loadPaymentData"}
            />
          ),
          color: "info",
          url: "/import/triveclite/paymentids?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load product images"} tKey={"vestigingen.form.service.label.loadImages"} />
          ),
          color: "info",
          url: "/import/triveclite/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/triveclite/menu?force=true&vid=" + vestigingId,
          params: {
            force: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Test connectie"} tKey={"vestigingen.form.service.label.connectiontest"} />
          ),
          color: "success",
          url: "/import/triveclite/connectiontest?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      TAURUS: [
        {
          label: <TranslationWrapper tDefault={"Get Settings"} tKey={"vestigingen.form.service.label.getSettings"} />,
          color: "info",
          url: "/import/taurus/getSettings?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Get Terminals"} tKey={"vestigingen.form.service.label.getTerminals"} />,
          color: "info",
          url: "/import/taurus/getTerminals?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/taurus/tables/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
      ],
      LIGHTSPEED: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/lightspeed/menu?&debug=true&gtd=true&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/lightspeed/tables/?&debug=true&vid=" + vestigingId,
          params: {
            debug: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment types"}
              tKey={"vestigingen.form.service.label.loadPaymentsTypes"}
            />
          ),
          color: "success",
          url: "/import/lightspeed/paymentids/?&debug=true&gtd=true&vid=" + vestigingId,
          params: {
            debug: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load product data & force options"}
              tKey={"vestigingen.form.service.label.loadForceOptions"}
            />
          ),
          color: "warning",
          url: "/import/lightspeed/menu?&debug=true&gtd=true&forceOptions=1&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            forceOptions: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/lightspeed/menu?&debug=true&gtd=true&force=1&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load product images"} tKey={"vestigingen.form.service.label.loadImages"} />
          ),
          color: "info",
          url: "/import/lightspeed/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      MPLUS: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "danger",
          url: "/import/mplus/changes?force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
          extraCheck: () => {
            return mplusautosyncValue != 0;
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/mplus/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
          extraCheck: () => {
            return mplusautosyncValue != 0;
          },
        },
        {
          label: <TranslationWrapper tDefault={"Data resync"} tKey={"vestigingen.form.service.label.dataReSync"} />,
          color: "danger",
          url: "/import/mplus/resync?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
          extraCheck: () => {
            return mplusautosyncValue == 1;
          },
        },
        {
          label: <TranslationWrapper tDefault={"Data sync"} tKey={"vestigingen.form.service.label.dataSync"} />,
          color: "warning",
          url: "/import/mplus/changes?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
          extraCheck: () => {
            return mplusautosyncValue == 1;
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load terminals"} tKey={"vestigingen.form.service.label.loadTerminals"} />
          ),
          color: "info",
          url: "/import/mplus/terminal?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load deliverymethods"}
              tKey={"vestigingen.form.service.label.loadDeliveryMethods"}
            />
          ),
          color: "info",
          url: "/import/mplus/deliverymethods?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Create deliverymethods"}
              tKey={"vestigingen.form.service.label.createDeliveryMethods"}
            />
          ),
          color: "info",
          url: "/import/mplus/createdeliverymethods?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment data"}
              tKey={"vestigingen.form.service.label.loadPaymentData"}
            />
          ),
          color: "info",
          url: "/import/mplus/getpaymentmethods?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load Employees"} tKey={"vestigingen.form.service.label.loadEmployees"} />
          ),
          color: "info",
          url: "/import/mplus/employees?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      TWELVE: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/twelve/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load customers"} tKey={"vestigingen.form.service.label.loadCustomers"} />
          ),
          color: "info",
          url: "/import/twelve/customers?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      LIGHTSPEEDK: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/lightspeedk/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load (LET OP WIST: MODIFIERS)"}
              tKey={"vestigingen" + "." + "form.service.label.forceLoadProductDataOnlyModifiers"}
            />
          ),
          color: "danger",
          url: "/import/lightspeedk/menu?force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load product images"} tKey={"vestigingen.form.service.label.loadImages"} />
          ),
          color: "info",
          url: "/import/lightspeedk/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "info",
          url: "/import/lightspeedk/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Show all available payment methods"}
              tKey={"vestigingen.form.service.label.showPaymentMethods"}
            />
          ),
          color: "info",
          url: "/import/lightspeedk/getpaymentmethods?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"First time setup"} tKey={"vestigingen.form.service.label.firstTimeSetup"} />
          ),
          color: "info",
          url: "/import/lightspeedk/firsttimesetup?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Webhooks"} tKey={"vestigingen.form.service.label.webhooks"} />,
          color: "danger",
          url: "/import/lightspeedk/webhooks?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
          wrap: (element) => {
            return (
              <AuthenticationWrapper child={element} permissionKey={"vestigingen.serviceapi.lightspeedkwebhook"} />
            );
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
        // {
        //   label: getTranslation("vestigingen.form.service.label.stock", "Update stock"),
        //   color: "info",
        //   url: "/import/lightspeedk/stock?vid=" + vestigingId,
        //   params: {
        //     vid: vestigingId,
        //   },
        // },
      ],
      CASHDESK: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/cashdesk/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/cashdesk/menu?&force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load product en menu images"}
              tKey={"vestigingen.form.service.label.loadProductImages"}
            />
          ),
          color: "info",
          url: "/import/cashdesk/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      NCRALOHA: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/aloha/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load stock data"} tKey={"vestigingen.form.service.label.loadStockData"} />
          ),
          color: "success",
          url: "/import/aloha/stock?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load product data (overwrite options)"}
              tKey={"vestigingen" + "." + "form.service.label.loadProductDataOptions"}
            />
          ),
          color: "warning",
          url: "/import/aloha/menu?force=2&vid=" + vestigingId,
          params: {
            force: 2,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load (LET OP WIST: MODIFIERS+KAARTEN)"}
              tKey={"vestigingen" + "." + "form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/aloha/menu?force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      GASTROFIX: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/gastrofix/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/gastrofix/menu?&force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load Employees"} tKey={"vestigingen.form.service.label.loadEmployees"} />
          ),
          color: "info",
          url: "/import/gastrofix/employees?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment types"}
              tKey={"vestigingen.form.service.label.loadPaymentsTypes"}
            />
          ),
          color: "success",
          url: "/import/gastrofix/paymentids/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      SIMPHONY: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/symphony2/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/symphony2/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment data"}
              tKey={"vestigingen.form.service.label.loadPaymentData"}
            />
          ),
          color: "info",
          url: "/import/symphony2/paymentids?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load revenue centers"}
              tKey={"vestigingen.form.service.label.loadRevenueCenters"}
            />
          ),
          color: "info",
          url: "/import/symphony2/revenuecenters?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product plu data"}
              tKey={"vestigingen.form.service.label.pluData"}
            />
          ),
          color: "warning",
          url: "/import/symphony2/pludata?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/symphony2/menu?force=true&vid=" + vestigingId,
          params: {
            force: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load product images"} tKey={"vestigingen.form.service.label.loadImages"} />
          ),
          color: "info",
          url: "/import/symphony2/images?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load Definition Sequences and Tags"}
              tKey={"vestigingen.form.service.label.definitionSequencesAndTags"}
            />
          ),
          color: "info",
          url: "/import/symphony2/definition_sequences",
          params: {
            vid: vestigingId,
          },
          onSuccess: () => {
            // Update the definition sequences dropdown options in the oracle tab
            axios.post("core/vestigingen/getCustomData", { vid: vestigingId }).then((response) => {
              let customData = getValues("custom_data");
              const definitionSequences = response?.data?.data?.oracleRest2?.definition_sequences ?? [];

              if ("oracleRest2" in customData) {
                customData.oracleRest2.definition_sequences = definitionSequences;
              } else {
                customData.oracleRest2 = {
                  definition_sequences: definitionSequences,
                };
              }

              setValue("custom_data", customData);
            });
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Clear accesstoken data"}
              tKey={"vestigingen.form.service.label.clearaccesstoken"}
            />
          ),
          color: "danger",
          url: "/import/symphony2/clearaccesstoken",
          params: {
            vid: vestigingId,
          },
        },
      ],
      MICROS3700: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/micros3700/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load (LET OP WIST: MODIFIERS+KAARTEN)"}
              tKey={"vestigingen" + "." + "form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/micros3700/menu?force=1&vid=" + vestigingId,
          params: {
            force: 1,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      NUVOPOS: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/nuvopos/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/nuvopos/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/nuvopos/menu?force=true&vid=" + vestigingId,
          params: {
            force: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"First time setup"} tKey={"vestigingen.form.service.label.firstTimeSetup"} />
          ),
          color: "info",
          url: "/import/nuvopos/firsttimesetup?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment types"}
              tKey={"vestigingen.form.service.label.loadPaymentsTypes"}
            />
          ),
          color: "success",
          url: "/import/nuvopos/paymentids/?&debug=true&gtd=true&vid=" + vestigingId,
          params: {
            debug: true,
            gtd: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      GREATPOS: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/greatpos/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "warning",
          url: "/import/greatpos/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/greatpos/menu?force=true&vid=" + vestigingId,
          params: {
            force: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment types"}
              tKey={"vestigingen.form.service.label.loadPaymentsTypes"}
            />
          ),
          color: "success",
          url: "/import/greatpos/paymentids/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      CLUBPLANNER: [
        {
          label: (
            <TranslationWrapper
              tDefault={"Load or sync product data"}
              tKey={"vestigingen.form.service.label.loadProductData"}
            />
          ),
          color: "info",
          url: "/import/clubplanner/menu?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Force load product data"}
              tKey={"vestigingen.form.service.label.forceLoadProductData"}
            />
          ),
          color: "danger",
          url: "/import/clubplanner/menu?force=true&vid=" + vestigingId,
          params: {
            force: true,
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper
              tDefault={"Load payment types"}
              tKey={"vestigingen.form.service.label.loadPaymentsTypes"}
            />
          ),
          color: "success",
          url: "/import/clubplanner/paymentids/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Reset syncstate"} tKey={"vestigingen.form.service.label.resetSyncState"} />
          ),
          color: "danger",
          url: "/manager/core/vestigingen/resetsyncstate",
          params: {
            vid: vestigingId,
          },
          type: "resetSyncState",
        },
      ],
      DELIVERECT: [
        {
          label: <TranslationWrapper tDefault={"Load tables"} tKey={"vestigingen.form.service.label.loadTables"} />,
          color: "info",
          url: "/import/deliverect/tables?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
        {
          label: (
            <TranslationWrapper tDefault={"Load locations"} tKey={"vestigingen.form.service.label.loadlocations"} />
          ),
          color: "warning",
          url: "/import/deliverect/getLocations/?vid=" + vestigingId,
          params: {
            vid: vestigingId,
          },
        },
      ],
    }),
    [vestigingId]
  );

  const oauthAction = useMemo(
    () => ({
      LIGHTSPEED: [
        {
          label: "Login OAuth",
          color: "danger",
          type: "lightspeed",
        },
      ],
      LIGHTSPEEDK: [
        {
          label: "Login OAuth",
          color: "danger",
          type: "lightspeedk",
        },
      ],
    }),
    []
  );

  const initAction = (action) => {
    if (!running || action?.type === "resetSyncState") {
      const http = axios.create({
        baseURL: "/",
      });

      let url = action.url;

      // Format action for post
      url = url.split("?")[0];
      url = url.endsWith("/") ? url.slice(0, -1) : url;

      if (action?.type === "resetSyncState") {
        http
          .post(url, action.params)
          .then((response) => {
            if (response.data.data.success) {
              toast.success(response.data.data.message);
              setRunning(false);
            } else {
              toast.error(response.data.data.message);
            }
          })
          .catch((err) => {
            toast.error(<TranslationWrapper tKey={"Something went wrong!"} />);
          });

        return;
      } else if (!running) {
        setRunning(true);

        http
          .get(url, { params: action.params })
          .then((response) => {
            const cacheKey = response.data;
            if (typeof cacheKey !== "string" || !cacheKey.startsWith("pos-import")) {
              toast.error(
                <TranslationWrapper tDefault={"Error. POS Action failed."} tKey={"Error. POS Action failed."} />
              );
              setIframeUrl("data:text/html;charset=utf-8," + escape(response.data + "<br />"));
              setIndex((prevValue) => prevValue + 1);
              setRunning(false);
              return;
            }

            pollUrl.current = "/import/" + cacheKey;

            poll({
              fn: pollPosCacheRequest,
              validate: pollPosCacheValidate,
              interval: 10000,
              maxAttempts: 270,
            })
              .then(() => {
                setIframeUrl(pollUrl.current);
                setIndex((prevValue) => prevValue + 1);
                setRunning(false);

                if (action.onSuccess) {
                  action.onSuccess();
                }
              })
              .catch((err) => console.log(err));
          })
          .catch((err) => {
            toast.error(
              <TranslationWrapper tDefault={"Error. POS Action failed."} tKey={"Error. POS Action failed."} />
            );
            setIframeUrl("data:text/plain;charset=utf-8," + escape(err.response.request.responseText + "<br />"));
            setIndex((prevValue) => prevValue + 1);
            setRunning(false);
          });
      }
    }
  };

  const poll = ({ fn, validate, interval, maxAttempts }) => {
    let attempts = 0;

    const executePoll = async (resolve, reject) => {
      const result = await fn();
      attempts++;

      if (validate(result)) {
        return resolve(result);
      } else if (maxAttempts && attempts === maxAttempts) {
        return reject(new Error("Exceeded max attempts"));
      } else {
        setTimeout(executePoll, interval, resolve, reject);
      }
    };

    return new Promise(executePoll);
  };

  const pollPosCacheRequest = async () => {
    const http = axios.create({
      baseURL: "/",
    });

    const response = await http.get(pollUrl.current).catch((err) => {
      return false;
    });

    return response.data;
  };

  const pollPosCacheValidate = (data) => {
    return data !== false && data !== undefined;
  };

  const redirectOAuth = (type) => {
    setOauthbusy(true);

    const url = "core/oauth/get_authorize_uri?api=" + type + "&vid=" + vestigingId;

    axios
      .get(url)
      .then((response) => {
        window.location = response.data.data.redirectUri;
      })
      .finally((response) => {
        setOauthbusy(false);
      });
  };

  const renderButtons = () => {
    let apiButtons = [];
    let oauthButtons = [];

    let api = apiProviderValue;

    if (apiActions[api] !== undefined) {
      apiButtons = apiActions[api].map((action, key) => {
        let button = null;

        /**
         * Als er een extra check is dan moet die ook true zijn
         */
        if (action.extraCheck !== undefined && action.extraCheck()) {
          if (action.wrap) {
            button = action.wrap(
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          } else {
            button = (
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          }
        }

        /**
         * Als er geen extra Check is dan altijd toevoegen
         */
        if (action.extraCheck === undefined) {
          if (action.wrap) {
            button = action.wrap(
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          } else {
            button = (
              <Button color={action.color} key={"api_" + key} onClick={() => initAction(action)}>
                {action.label}
              </Button>
            );
          }
        }

        return button;
      });
    }

    if (isMappsParent) {
      apiButtons.push(
        <Button
          color={""}
          key={"mapps"}
          onClick={() =>
            initAction({
              url: "/manager/core/MultiAreaSync/sync",
              params: {
                sales_area_id: vestigingId,
              },
            })
          }
        >
          <TranslationWrapper tDefault={"Multi Area Sync"} tKey={"vestigingen.form.service.label.multi_area_sync"} />
        </Button>
      );
    }

    if (oauthAction[api] !== undefined) {
      oauthButtons = oauthAction[api].map((action, key) => {
        let button = null;
        button = (
          <SaveButton
            buttonText={action.label}
            color={action.color}
            key={"oauth_" + key}
            onClick={() => redirectOAuth(action.type)}
            saving={oauthbusy}
          />
        );

        return button;
      });
    }

    return [...apiButtons, ...oauthButtons];
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridContainer>
            <GridItem>
              {running ? (
                <CircularProgress
                  style={{
                    width: "30px",
                    height: "30px",
                    position: "relative",
                    top: "10px",
                    marginRight: "10px",
                  }}
                />
              ) : null}
              {renderButtons()}
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem md={12} xs={12}>
              <iframe
                id={"logOutput"}
                key={index}
                src={iframeUrl}
                style={{
                  width: "100%",
                  height: "500px",
                  borderStyle: "solid",
                  borderWidth: "1px",
                  borderColor: "#afafaf",
                }}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
      {/*{apiProviderValue == "UNTILL" ? <ApiCalls /> : null}*/}
    </div>
  );
}

export default Service;
